module.exports = __webpack_public_path__ + "static/media/greeitem2.df2937b3.png";